module.exports = __webpack_public_path__ + "static/media/CK.0e4eaabf.svg";